<template>
  <div class="bannerHelp">
    <div class="bannerHelp__toggle" v-if="isMobile" @click="hideBanner"></div>
    <div class="bannerHelp__content">
      <p>Hai qualche dubbio?</p>
      <p><strong>Contattaci</strong></p>
    </div>
    <div class="bannerHelp__quickLinks">
      <div v-for="link in quicklinks" :class="getLinkClass(link.name)">
        <a :href="link.href" target="_blank">
          <img :src="link.imgPath" alt=""/>
          <div v-if="link.hasNumber">
            <span>0297190019</span>
          </div>
        </a>
      </div>
    </div>
    <div class="bannerHelp__img">
      <img :src="returnBasePath('/assets/img/shared/corner-man.png')" alt="Desivero"/>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return {
        "quicklinks": [
          {
            "name": "mail",
            "imgPath": WIZARD.assetsBasePath + "/assets/img/shared/icon-mail.png",
            "type": "link",
            "href": "https://www.desivero.com/contatti"
          },
          {
            "name": "chat",
            "imgPath": WIZARD.assetsBasePath + "/assets/img/shared/icon-chat.png",
            "type": "link",
            "href": "https://www.smartsuppchat.com/widget?key=75428593c4d0726947a4a0163da30f962c90958b&vid=8Gn4b8DkfXixKBbF2Q6WVIEwt4jk8xZgs524431026032018&group=&lang=it&pageTitle=Desivero%20%E2%80%93%20soluzioni%20per%20il%20bagno%2C%20il%20riscaldamento%20e%20la%20climatizzazione&pageUrl=https%3A%2F%2Fwww.desivero.com%2F&domain=www.desivero.com&referer="
          },
          {
            "name": "phone",
            "imgPath": WIZARD.assetsBasePath + "/assets/img/shared/icon-phone.png",
            "type": "link",
            "href": "tel:0297190019",
            "hasNumber": false
          }
        ]
      }
    },
    computed: {
      isMobile(){
        return window.innerWidth < 768;
      }
    },
    methods: {
      hideBanner(){
        $('.bannerHelp').toggleClass('is-hidden');
      },
      checkPhoneResolution(){
        var windowWidth = $(window).innerWidth();
        if (windowWidth >= 768) {
          this.quicklinks[2].href = 'javascript:void(0)';
          this.quicklinks[2].hasNumber = true;
        }
        else {
          this.quicklinks[2].href = 'tel:0297190019';
          this.quicklinks[2].hasNumber = false;
        }
      },
      getLinkClass(name){
        return 'bannerHelp__quickLinks__item bannerHelp__quickLinks__item--' + name;
      }
    },
    mounted(){
      var vm = this;
      vm.checkPhoneResolution();
      $(window).on('resize', vm.checkPhoneResolution);
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/globals/BannerHelp.vue